import { render, staticRenderFns } from "./Slogans.vue?vue&type=template&id=48c34fde&scoped=true&"
import script from "./Slogans.vue?vue&type=script&lang=ts&"
export * from "./Slogans.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c34fde",
  null
  
)

export default component.exports